import * as React from "react"
import { MarketingNav } from "./MarketingNav"
import { MarketingFooter } from "./MarketingFooter"

export function MarketingLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-page">
      {/* Skip link — must be the first focusable element so keyboard and
          screen-reader users can jump past the nav on every page. Visually
          hidden until focused. */}
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-ink-display focus:px-4 focus:py-2 focus:text-page focus:no-underline"
      >
        Skip to main content
      </a>
      <MarketingNav />
      <main id="main" className="flex-1">
        {children}
      </main>
      <MarketingFooter />
    </div>
  )
}
